import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { isNil } from 'lodash'

import { createOperationRoleApi } from '@eastcoal/api/auth/operationRole/createOperationRole'
import { updateOperationRoleApi } from '@eastcoal/api/auth/operationRole/updateOperationRole'
import { queryRoleApi } from '@eastcoal/api/auth/role/queryRole'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { Switch } from '@eastcoal/formily/components/Switch'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { useNavigate } from '@eastcoal/router/exports/react-router'
import { ResourceTree } from '@eastcoal/shared/@formily/ResourceTree'

import { CodeInput } from './CodeInput'
import { RoleFormPrivateProps, RoleFromProps } from './interface'

const items: RoleFormPrivateProps['schema'] = [
  {
    name: 'name',
    title: '角色名称',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'builtin',
    title: '是否为内置角色',
    type: 'string',
    'x-component': Switch,
    'x-decorator': FormItem
  },
  {
    name: 'code',
    title: (
      <Tooltip title='只能输入字母或下划线（_)'>
        <span>角色编码&nbsp;</span>
        <QuestionCircleOutlined />
      </Tooltip>
    ),
    type: 'string',
    'x-display': "{{$values.builtin ? 'visible' : 'none'}}",
    required: true,
    'x-component': CodeInput,
    'x-decorator': FormItem
  },
  {
    name: 'description',
    title: '描述信息',
    type: 'string',
    'x-component': TextArea,
    'x-decorator': FormItem
  },
  {
    name: 'resources',
    title: '资源权限',
    type: 'array',
    'x-component': ResourceTree,
    'x-decorator': FormItem
  }
]

const layout: RoleFormPrivateProps['layout'] = {
  wrapperWidth: 320
}

const readApi: RoleFormPrivateProps['readApi'] = ({ id }) => {
  return {
    api: () => queryRoleApi({ id }),
    ready: !isNil(id)
  }
}

export const RoleForm = ({ mode }: RoleFromProps) => {
  const navigator = useNavigate()
  return (
    <PageContainer>
      <CrudForm
        createApi={createOperationRoleApi}
        layout={layout}
        mode={mode}
        name='roleForm'
        readApi={readApi}
        schema={items}
        updateApi={updateOperationRoleApi}
        actions={[
          <BackButton key='backButton' />,
          <SaveButton key='saveButton' />,
          <SubmitButton key='submitButton' />
        ]}
        onSuccess={() => navigator(-1)}
      />
    </PageContainer>
  )
}
